(function ($) {
    $(document).ready(function () {

        $('.section-continuous-slider .first-slider').marquee({
            duration: 30000,
            gap: 16,
            delayBeforeStart: 0,
            direction: 'left',
            duplicated: true
        });

        $('.section-continuous-slider .second-slider').marquee({
            duration: 30000,
            gap: 16,
            delayBeforeStart: 0,
            direction: 'right',
            duplicated: true
        });
    });
})(jQuery);
